import { Box, Button, Portal, Text } from '@chakra-ui/react';
import ApiClient from '@config/network';
import { useCheckoutConfigContext } from '@contexts/CheckoutConfig';
import { useDonateButtonRef } from '@contexts/DonateButtonRef';
import { FormValues, SatispayPM } from '@types';
import { FC, useState } from 'react';
import { useFormContext } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import { When } from 'react-if';

interface Props {
  method: SatispayPM;
  onComplete: () => Promise<void>;
  onError: (error: string) => void;
}

const SatispayPanel: FC<Props> = ({ method, onComplete, onError }) => {
  const { ref } = useDonateButtonRef();
  const { checkout } = useCheckoutConfigContext();
  const { t } = useTranslation();
  const [loading, setLoading] = useState(false);

  const { watch } = useFormContext<FormValues>();

  async function handleDonate() {
    setLoading(true);

    const { data } = await ApiClient.post<{ redirect_url: string }>(
      `rest/v1/checkout/satispay/${checkout.token}/payment`,
      null,
    );

    window.location.href = data.redirect_url;
    setLoading(false);
  }

  if (!ref?.current) return null;
  return (
    <Box textAlign="center">
      <svg
        xmlns="http://www.w3.org/2000/svg"
        fill="none"
        viewBox="0 0 24 24"
        strokeWidth="1.5"
        stroke="currentColor"
        style={{
          width: '80px',
          height: '80px',
          margin: '0 auto',
        }}
      >
        <path
          strokeLinecap="round"
          strokeLinejoin="round"
          d="M13.5 4.5 21 12m0 0-7.5 7.5M21 12H3"
        />
      </svg>

      <Text mt={4}>
        {t(
          'After clicking on Donate button you will be redirect on Satispay to complete your donation',
        )}
      </Text>

      <Portal containerRef={ref}>
        <When condition={watch('paymentMethodId') === method.id}>
          <Button
            size="lg"
            w={{ base: 'full', lg: '100px' }}
            alignSelf="flex-end"
            mt="auto"
            colorScheme="primary"
            isLoading={loading}
            disabled={loading}
            onClick={handleDonate}
          >
            {t('Donate')}
          </Button>
        </When>
      </Portal>
    </Box>
  );
};

export default SatispayPanel;
